(function () {
  const hero = document.querySelector('[data-hero-carousel]');
  if (!hero) return;

  const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
  const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
  if (slides.length <= 1) return;

  hero.classList.add('is-js');

  const intervalMs = 3600;
  let current = 0;
  let timer = null;

  function render(nextIndex) {
    current = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === current));
    dots.forEach((dot, index) => {
      const active = index === current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function next() {
    render(current + 1);
  }

  function start() {
    window.clearInterval(timer);
    timer = window.setInterval(next, intervalMs);
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', function () {
      render(index);
      start();
    });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) window.clearInterval(timer);
    else start();
  });

  render(0);
  window.setTimeout(function () {
    next();
    start();
  }, 1800);
})();
